(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hw-carousel-navigation"] && !Shopify.designMode) return;
  try {
    (function() {
    const isDesignMode =
      (typeof Shopify !== 'undefined' && Shopify.designMode) ||
      document.body.classList.contains('shopify-design-mode');

    /** Mirrors @theme/events SlideshowSelectEvent (bundled snippet cannot import). */
    const SLIDESHOW_SELECT = 'slideshow:select';

    /**
     * Quiet period after the last `scroll` event before treating a scroll as
     * settled. Comfortably above scrolling.js's 50ms SCROLL_END_TIMEOUT so the
     * re-sync lands after slideshow-component's own scroll-end work.
     */
    const SCROLL_SETTLE_DELAY = 120;

    /** Quiet period after the last `resize` event before re-measuring. */
    const RESIZE_SETTLE_DELAY = 150;

    /**
     * Mirror slideshow `set current` disabled rule for nav placed *outside*
     * <slideshow-component>: prev disabled at index 0, next disabled when
     * current + visibleCount >= total (current = leftmost visible per #sync).
     *
     * For drag-ended slides slideshow dispatches slideshow:select *before*
     * this.current is reassigned — accept event.detail.index as fresh value.
     *
     * @param {HTMLElement} slideshowEl - slideshow-component instance
     * @param {HTMLElement} navigationRoot
     * @param {number | CustomEvent<{ index?: number }> | Event} [eventOrIndex]
     */
    function syncHwNavArrowDisabled(slideshowEl, navigationRoot, eventOrIndex) {
      const prevBtn = navigationRoot.querySelector('[ref="previous"]');
      const nextBtn = navigationRoot.querySelector('[ref="next"]');

      if (!prevBtn && !nextBtn) {
        return;
      }

      const slides = slideshowEl.slides;
      const len = slides?.length ?? 0;

      if (!len) {
        if (prevBtn) {
          prevBtn.disabled = true;
        }

        if (nextBtn) {
          nextBtn.disabled = true;
        }

        applyHwNavDisabledColorScheme(navigationRoot);
        return;
      }

      const raw = slideshowEl.current;
      let value = typeof raw === 'number' ? raw : 0;

      if (typeof eventOrIndex === 'number' && eventOrIndex >= 0) {
        value = eventOrIndex;
      } else if (
        eventOrIndex &&
        typeof eventOrIndex === 'object' &&
        'detail' in eventOrIndex &&
        eventOrIndex.detail &&
        typeof eventOrIndex.detail.index === 'number' &&
        eventOrIndex.detail.index >= 0
      ) {
        value = eventOrIndex.detail.index;
      }

      const infinite = slideshowEl.infinite;

      if (prevBtn) {
        prevBtn.disabled = Boolean(!infinite && value <= 0);
      }

      if (nextBtn) {
        /*
         * Mirror slideshow-component's own `set current` (slideshow.js):
         * prefer real scroll overflow to detect end-of-content. The
         * visibleSlides/step heuristic alone can under- or over-count (an
         * IntersectionObserver threshold miss, or a tab panel that was just
         * unhidden and hasn't reported its visible slides yet), which left
         * "next" clickable even when every slide already fit on screen with
         * nothing left to scroll to.
         *
         * Derive that from where the scroller *will* rest for `value`, never
         * from a live `scrollLeft` read: `slideshow:select` is dispatched on
         * frame 0 of a smooth scroll (`select()` kicks off `#scroll.to()` and
         * dispatches immediately), so mid-animation `scrollLeft` still holds
         * the *old* position. Jumping back from the end of the carousel then
         * read as "still at the end" and disabled "next" at the same moment
         * `value <= 0` correctly disabled "previous" — both arrows dead, with
         * nothing to re-sync them (see the scroll-settle listener below).
         *
         * `offsetLeft - paddingInlineStart` is the exact target Scroller#to
         * scrolls to (assets/scrolling.js); the browser clamps it to
         * [0, maxScroll], so clamping it here gives the resting position
         * independent of animation state.
         */
        const scroller = slideshowEl.querySelector('slideshow-slides');
        const measurable = Boolean(scroller) && scroller.clientWidth > 0;
        let atScrollEnd;

        if (measurable && scroller.scrollWidth > scroller.clientWidth + 1) {
          const maxScroll = scroller.scrollWidth - scroller.clientWidth;
          const targetSlide = slides[value];
          let restingScroll = scroller.scrollLeft;

          if (targetSlide) {
            const paddingStart =
              parseFloat(getComputedStyle(scroller).paddingInlineStart) || 0;

            restingScroll = Math.min(
              Math.max(targetSlide.offsetLeft - paddingStart, 0),
              maxScroll
            );
          }

          atScrollEnd = restingScroll >= maxScroll - 1;
        } else if (measurable) {
          // No measurable overflow — every slide already fits, nothing to scroll to.
          atScrollEnd = true;
        } else {
          /*
           * Unmeasurable: a tab panel that is still `display: none` reports
           * scrollWidth === clientWidth === 0, which is indistinguishable from
           * "everything fits" — and combined with `value === 0` that disabled
           * both arrows. Fall back to slide counting; `hw-tabs:activate`
           * re-syncs once the panel has real dimensions.
           */
          const vis = slideshowEl.visibleSlides;
          const visCount = vis && vis.length ? vis.length : 1;
          const step = Math.min(visCount, len);
          atScrollEnd = value + step >= len;
        }

        nextBtn.disabled = Boolean(!infinite && atScrollEnd);
      }

      applyHwNavDisabledColorScheme(navigationRoot);
    }

    /**
     * @param {HTMLElement} navigationRoot
     */
    function applyHwNavDisabledColorScheme(navigationRoot) {
      if (navigationRoot.dataset.hwCartUpsellsNav === 'true') {
        return;
      }

      const enabledSchemeClass = navigationRoot.dataset.enabledColorScheme;
      const disabledSchemeClass = navigationRoot.dataset.disabledColorScheme;

      if (!enabledSchemeClass && !disabledSchemeClass) {
        return;
      }

      const buttons = navigationRoot.querySelectorAll(
        '.hw-carousel-navigation__control, .slideshow-control'
      );

      buttons.forEach((btn) => {
        const isDisabled = btn.disabled;

        if (isDisabled) {
          if (enabledSchemeClass) {
            btn.classList.remove(enabledSchemeClass);
          }

          if (disabledSchemeClass) {
            btn.classList.add(disabledSchemeClass);
            btn.classList.add('hw-carousel-navigation__control--disabled-scheme');
          }

          return;
        }

        if (disabledSchemeClass) {
          btn.classList.remove(disabledSchemeClass);
          btn.classList.remove('hw-carousel-navigation__control--disabled-scheme');
        }

        if (enabledSchemeClass) {
          btn.classList.add(enabledSchemeClass);
        }
      });
    }

    /**
     * @param {HTMLElement} navigation
     * @returns {HTMLElement|null}
     */
    function resolveNavSlideshow(navigation) {
      const targetId = navigation.dataset.targetSlideshow;
      if (targetId) {
        return document.querySelector('[data-slideshow-id="' + targetId + '"]');
      }

      const tabbedRoot = navigation.closest('[data-hw-tabbed-carousel]');
      if (tabbedRoot) {
        const visiblePanel = tabbedRoot.querySelector(
          '[data-hw-tab-panel]:not([hidden])'
        );
        return visiblePanel
          ? visiblePanel.querySelector('slideshow-component')
          : null;
      }

      const sectionRoot = navigation.closest('.section-carousel-grid');
      return sectionRoot
        ? sectionRoot.querySelector('slideshow-component')
        : null;
    }

    /**
     * Wire each HW carousel nav to its section slideshow. The bundled javascript
     * tag has no reliable document.currentScript, so we must not assume a single instance.
     *
     * @param {HTMLElement} navigation
     */
    function connectNavigation(navigation) {
      if (navigation.dataset.hwCartUpsellsNav === 'true') {
        return;
      }

      let slideshow;

      const findSlideshow = () => {
        slideshow = resolveNavSlideshow(navigation);
        return slideshow;
      };

      let retryCount = 0;
      const connectArrows = () => {
        retryCount++;

        if (!findSlideshow()) {
          if (retryCount < 50) {
            setTimeout(connectArrows, 100);
          }

          return;
        }

        customElements.whenDefined('slideshow-component').then(() => {
          if (!slideshow || navigation.dataset.hwCarouselNavSynced === '1') {
            return;
          }

          const arrows = navigation.querySelectorAll(
            '.hw-carousel-navigation__control, .slideshow-control'
          );

          if (arrows.length === 0) {
            return;
          }

          navigation.dataset.hwCarouselNavSynced = '1';

          if (!isDesignMode) {
            arrows.forEach((arrow) => {
              const action = arrow.getAttribute('ref');

              if (action === 'previous' || action === 'next') {
                arrow.removeAttribute('on:click');
                arrow.addEventListener('click', (e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  const activeSlideshow = findSlideshow();
                  if (!activeSlideshow) return;

                  if (action === 'next' && activeSlideshow.next) {
                    activeSlideshow.next(e);
                  } else if (action === 'previous' && activeSlideshow.previous) {
                    activeSlideshow.previous(e);
                  }
                });
              }
            });
          }

          /**
           * Tab panels swap slideshow instances; delegate on document so the
           * active tab's slideshow:select updates this nav's arrow disabled state.
           *
           * @param {Event} event
           */
          const onSlideSelect = (event) => {
            const eventSlideshow = event.target?.closest?.(
              'slideshow-component'
            );
            const activeSlideshow = findSlideshow();

            if (
              !eventSlideshow ||
              !activeSlideshow ||
              eventSlideshow !== activeSlideshow
            ) {
              return;
            }

            syncHwNavArrowDisabled(activeSlideshow, navigation, event);
          };

          document.addEventListener(SLIDESHOW_SELECT, onSlideSelect, true);

          let scrollSettleTimer = 0;

          /**
           * Re-sync once the scroll actually lands, so a computation taken
           * mid-animation can correct itself.
           *
           * slideshow-component emits no event at scroll-end: #onTransitionEnd
           * only re-runs #sync() (which fixes its *own* refs), and #handleScroll
           * bails with `if (index === previousIndex) return` because select()
           * already wrote the new index. So after an arrow click this nav never
           * hears about the settled position and keeps whatever state it
           * computed on frame 0 until an unrelated trigger fires.
           *
           * `scroll` doesn't bubble, but capture-phase listeners on document
           * still receive it — which also keeps the tab-panel delegation that
           * onSlideSelect relies on.
           *
           * @param {Event} event
           */
          const onScrollSettle = (event) => {
            const target = event.target;

            if (
              !(target instanceof Element) ||
              target.tagName !== 'SLIDESHOW-SLIDES'
            ) {
              return;
            }

            const activeSlideshow = findSlideshow();

            if (!activeSlideshow || !activeSlideshow.contains(target)) {
              return;
            }

            clearTimeout(scrollSettleTimer);
            scrollSettleTimer = setTimeout(() => {
              syncHwNavArrowDisabled(findSlideshow(), navigation);
            }, SCROLL_SETTLE_DELAY);
          };

          document.addEventListener('scroll', onScrollSettle, true);

          syncHwNavArrowDisabled(slideshow, navigation);
          requestAnimationFrame(() => {
            syncHwNavArrowDisabled(findSlideshow(), navigation);
          });
          setTimeout(() => {
            syncHwNavArrowDisabled(findSlideshow(), navigation);
          }, 100);
        });
      };

      connectArrows();
    }

    document.addEventListener('hw-tabs:activate', (event) => {
      const tabbedRoot = event.target.closest('[data-hw-tabbed-carousel]');
      if (!tabbedRoot) return;

      tabbedRoot.querySelectorAll('.hw-carousel-navigation').forEach((navigation) => {
        if (navigation.dataset.hwCartUpsellsNav === 'true') return;
        const slideshow = resolveNavSlideshow(navigation);
        if (slideshow) {
          syncHwNavArrowDisabled(slideshow, navigation);
        }
      });
    });

    /*
     * Re-measure every nav after a resize or orientation change.
     *
     * `has_carousel` is decided server-side, so a section set to carousel on
     * one breakpoint and grid on another ships one slideshow-component and
     * switches with CSS. At a grid breakpoint the scroller has no overflow, so
     * "next" is correctly disabled — but nothing recomputed that when the
     * viewport crossed back to a carousel breakpoint and the nav un-hid,
     * leaving a dead arrow (hw-featured-blog: grid on desktop, carousel on
     * mobile/tablet). Rotating a device also changes how many slides fit, and
     * therefore maxScroll and whether the resting position is the end.
     *
     * slideshow-component's ResizeObserver only calls #updateVisibleSlides()
     * and #updateControlsVisibility() — it dispatches no event — so this nav
     * has to measure for itself. `resize` covers orientationchange in every
     * browser we support.
     */
    let navResizeTimer = 0;

    const resyncAllNavs = () => {
      document.querySelectorAll('.hw-carousel-navigation').forEach((navigation) => {
        if (navigation.dataset.hwCartUpsellsNav === 'true') {
          return;
        }

        const slideshow = resolveNavSlideshow(navigation);

        if (slideshow) {
          syncHwNavArrowDisabled(slideshow, navigation);
        }
      });
    };

    window.addEventListener('resize', () => {
      clearTimeout(navResizeTimer);
      navResizeTimer = setTimeout(resyncAllNavs, RESIZE_SETTLE_DELAY);
    });

    document.querySelectorAll('.hw-carousel-navigation').forEach(connectNavigation);

    document.querySelectorAll('.hw-carousel-navigation').forEach((navigation) => {
      if (navigation.dataset.hwCartUpsellsNav === 'true') {
        return;
      }

      applyHwNavDisabledColorScheme(navigation);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hw-carousel-progress-bar"] && !Shopify.designMode) return;
  try {
    (function() {
    /**
     * @param {HTMLElement} progressBar
     * @returns {HTMLElement|null}
     */
    function resolveSlideshow(progressBar) {
      const targetId = progressBar.dataset.targetSlideshow;
      if (targetId) {
        return document.querySelector('[data-slideshow-id="' + targetId + '"]');
      }

      const tabbedRoot = progressBar.closest('[data-hw-tabbed-carousel]');
      if (tabbedRoot) {
        const visiblePanel = tabbedRoot.querySelector(
          '[data-hw-tab-panel]:not([hidden])'
        );
        return visiblePanel
          ? visiblePanel.querySelector('slideshow-component')
          : null;
      }

      const section = progressBar.closest('.section-carousel-grid');
      return section ? section.querySelector('slideshow-component') : null;
    }

    function wireProgressBar(progressBar) {
      if (!progressBar) return true;

      if (progressBar._hwProgressCleanup) {
        progressBar._hwProgressCleanup();
        progressBar._hwProgressCleanup = null;
      }

      const slideshow = resolveSlideshow(progressBar);
      if (!slideshow) return false;

      const progressThumb = progressBar.querySelector('.hw-carousel-progress-bar__thumb');
      const slideshowSlides = slideshow.querySelector('slideshow-slides');
      if (!progressThumb || !slideshowSlides) return false;

      const updateProgress = () => {
        const scrollLeft = slideshowSlides.scrollLeft;
        const scrollWidth = slideshowSlides.scrollWidth;
        const clientWidth = slideshowSlides.clientWidth;
        const maxScroll = scrollWidth - clientWidth;

        if (maxScroll > 0) {
          const scrollProgress = Math.min(Math.max(scrollLeft / maxScroll, 0), 1);
          const fillWidth = 20 + scrollProgress * 80;
          progressThumb.style.left = '0%';
          progressThumb.style.width = fillWidth + '%';
        } else {
          progressThumb.style.width = '100%';
          progressThumb.style.left = '0%';
        }
      };

      slideshowSlides.addEventListener('scroll', updateProgress);
      /*
       * SlideshowSelectEvent.eventName is 'slideshow:select' (colon) — the
       * previous 'slideshow-select' (hyphen) never fired so programmatic
       * arrow clicks didn't repaint the bar between scrolls.
       */
      slideshow.addEventListener('slideshow:select', updateProgress);

      let resizeTimeout;
      const onResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateProgress, 100);
      };
      window.addEventListener('resize', onResize);

      progressBar._hwProgressCleanup = () => {
        slideshowSlides.removeEventListener('scroll', updateProgress);
        slideshow.removeEventListener('slideshow:select', updateProgress);
        window.removeEventListener('resize', onResize);
      };

      requestAnimationFrame(updateProgress);
      progressBar.setAttribute('data-hw-progress-wired', 'true');
      return true;
    }

    let attempts = 0;
    const maxAttempts = 50;

    function tryWireAll() {
      const bars = Array.from(
        document.querySelectorAll('.hw-carousel-progress-bar[data-progress-id]')
      );
      if (!bars.length) return;

      let pending = 0;
      bars.forEach((bar) => {
        if (bar.getAttribute('data-hw-progress-wired') === 'true') return;
        if (!wireProgressBar(bar)) pending += 1;
      });

      if (pending === 0 || attempts >= maxAttempts) return;
      attempts += 1;
      setTimeout(tryWireAll, 100);
    }

    document.addEventListener('hw-tabs:activate', (event) => {
      const tabbedRoot = event.target.closest('[data-hw-tabbed-carousel]');
      if (!tabbedRoot) return;

      tabbedRoot
        .querySelectorAll('.hw-carousel-progress-bar[data-progress-id]')
        .forEach((bar) => {
          bar.removeAttribute('data-hw-progress-wired');
          wireProgressBar(bar);
        });
    });

    tryWireAll();
  })();
  } catch(e) { console.error(e); }
})();

})();
